import React from "react";

export default function SlateTourCard({
    step,
    stepIndex,
    totalSteps,
    spotlightRect,
    onNext,
    onBack,
    onSkip,
    canGoBack
}) {
    if (!step) return null;
    let cardStyle = {};
    if (step.position === "center" || !spotlightRect) {
        // Centered card
        cardStyle = {
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
        };
    } else {
        const CARD_WIDTH = 280;
        const GAP = 20;
        // Center the card horizontally on the spotlight
        let left = spotlightRect.left + (spotlightRect.width / 2) - (CARD_WIDTH / 2);

        let maxRight = window.innerWidth - 16;
        let minLeft = 16;
        const mainEl = document.querySelector(".try-slate-main") || document.querySelector(".page");
        if (mainEl) {
            const mainRect = mainEl.getBoundingClientRect();
            minLeft = Math.max(16, mainRect.left);
            maxRight = Math.min(window.innerWidth - 16, mainRect.right);
        }

        if (left < minLeft) {
            left = minLeft;
        } else if (left + CARD_WIDTH > maxRight) {
            left = maxRight - CARD_WIDTH;
        }

        // Calculate where the arrow should point relative to the card
        let arrowLeft = (spotlightRect.left + spotlightRect.width / 2) - left;

        // Clamp the arrow so it doesn't fall off the rounded corners of the card
        const arrowMin = 24;
        const arrowMax = CARD_WIDTH - 24;
        if (arrowLeft < arrowMin) arrowLeft = arrowMin;
        if (arrowLeft > arrowMax) arrowLeft = arrowMax;

        let top = spotlightRect.top + spotlightRect.height + GAP;
        let isAbove = false;
        if (top + 200 > window.innerHeight) {
            top = spotlightRect.top - 200 - GAP;  // flip to above
            isAbove = true;
        }

        cardStyle = {
            position: "fixed",
            left: `${left}px`,
            top: `${top}px`,
        };

        // Add the arrow left position to card style so we can use it
        cardStyle.arrowLeft = arrowLeft;
        cardStyle.isAbove = isAbove;
    }

    return (
        <>
            {!spotlightRect && (
                <div className="tour-backdrop" aria-hidden="true" />
            )}

            {spotlightRect && (
                <>
                    {/* Visual spotlight ring */}
                    <div
                        className="tour-spotlight"
                        style={{
                            top: spotlightRect.top - 6,
                            left: spotlightRect.left - 6,
                            width: spotlightRect.width + 12,
                            height: spotlightRect.height + 12,
                        }}
                        aria-hidden="true"
                    />

                    {/* Invisible blockers to prevent clicking outside the spotlighted button */}
                    <div style={{ position: "fixed", top: 0, left: 0, right: 0, height: spotlightRect.top, zIndex: 999 }} />
                    <div style={{ position: "fixed", top: spotlightRect.top + spotlightRect.height, bottom: 0, left: 0, right: 0, zIndex: 999 }} />
                    <div style={{ position: "fixed", top: spotlightRect.top, height: spotlightRect.height, left: 0, width: spotlightRect.left, zIndex: 999 }} />
                    <div style={{ position: "fixed", top: spotlightRect.top, height: spotlightRect.height, left: spotlightRect.left + spotlightRect.width, right: 0, zIndex: 999 }} />
                </>
            )}

            <div
                className="tour-card"
                style={cardStyle}
                role="dialog"
                aria-modal="true"
                aria-label={`Tour step: ${step.title}`}
            >
                {step.position !== "center" && spotlightRect && (
                    <div
                        className={`tour-card-arrow ${cardStyle.isAbove ? 'is-above' : ''}`}
                        style={{ left: `${cardStyle.arrowLeft}px` }}
                        aria-hidden="true"
                    />
                )}

                <button
                    className="tour-skip-btn"
                    onClick={onSkip}
                    aria-label="Skip tour"
                >
                    Skip ✕
                </button>

                <div className="tour-step-counter">
                    {stepIndex + 1} / {totalSteps}
                </div>

                <div className="tour-card-header">
                    {step.icon && <span className="tour-card-icon">{step.icon}</span>}
                    <h3 className="tour-card-title">{step.title}</h3>
                </div>

                <p className="tour-card-desc">{step.desc}</p>

                <div className="tour-card-actions">
                    <button
                        className="tour-back-btn"
                        onClick={onBack}
                        disabled={!canGoBack}
                        aria-label="Previous tour step"
                        type="button"
                    >
                        Back
                    </button>
                    <button
                        className="tour-next-btn"
                        onClick={onNext}
                        aria-label={step.isFinal ? "Finish tour" : "Next step"}
                        type="button"
                    >
                        {step.isFinal ? "Done" : "Next"}
                    </button>
                </div>
            </div>
        </>
    );
}